import React,{useRef,useEffect,useState} from "react";
import ReactPlayer from "react-player/lazy";
import classes from './VideoComponent.module.css';


const VideoComponent = ({
  videoItem,
  showControls = true,
}) => {

  const playerRef = useRef(null);
  const [played,setPlayed] = useState('');
  const [isReady,setIsReady] = useState(false)


  const videoUrl=videoItem?.videoUrl;

  useEffect(() => {
    const savedTime = localStorage.getItem(videoUrl);
    if (savedTime) {
      setPlayed(parseFloat(savedTime));
    }
  }, []);

  const handlePause=()=>{
    // console.log(playerRef.current.getCurrentTime())
    const currentTime = playerRef.current.getCurrentTime();
    localStorage.setItem(videoUrl,currentTime);
  }

  const handleReady = () => {
    if (!isReady && played > 0) {
      playerRef.current.seekTo(played);
      setIsReady(true);
    }
  };

 // console.log("videoUrl ", videoUrl);
  if (videoItem?.videoUrl != "")
    return (
<div className={classes.video_player}>
        <ReactPlayer
        ref={playerRef}
          url={videoUrl}
          playing={true}
          controls={showControls}
          width="100%"
          height="100%"
          style={{ position: "absolute" }}
          progressInterval={200}
          playsinline={true}
          onPause={handlePause}
          onEnded={() => localStorage.removeItem(videoUrl)}
          onReady={handleReady}
        />
</div>

    );
};

export default VideoComponent;

